import React, { useEffect, useState, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DropdownButton } from 'react-bootstrap';
//icons
import { AiOutlineEye } from 'react-icons/ai';
//api
import { getGalleryCategories, deleteGallery } from 'api/gallery';
import { getPaginatedGallery } from 'api/pathForHook/gallery';
//custom hooks
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import Title from 'components/backoffice/texts/title';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import SearchTable from 'components/backoffice/table/SearchTable';
import Select from 'components/backoffice/selects/SelectCustom';
import WatchModal from 'components/backoffice/modals/WatchModal';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import GalleryModal from './modal';

const GalleryManagement = () => {
  const userPermissions = usePermissions();
  const { t } = useTranslation(['backoffice']);
  const [galleryItems, setGalleryItems] = useState([]);
  const [item, setItem] = useState({});
  const [page, setPage] = useState(1);
  const [typeAction, setTypeAction] = useState('create');
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalImage, setOpenModalImage] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [categories, setCategories] = useState([]);
  const [responseInfo, setResponseInfo] = useState({});
  const { setTitle } = useOutletContext()

  const { fetchData, stateData, loading } = useHandleSearch()

  const getListGallery = async () => {
    try {
      const payload = {
        page: page,
        page_size: 10,
        category: inputValue,
        fields: 'id,image,category'
      };
      await fetchData(getPaginatedGallery(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTitle(t('gallery'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setGalleryItems(results);
      setResponseInfo({ errors, totalPages, noResults })
    } else {
      setGalleryItems(null);
      setResponseInfo({ errors })
    }
  }, [stateData])

  useEffect(() => {
    if (page > 1 && inputValue !== '') {
      setPage(1)
    }
  }, [inputValue])


  useEffect(() => {
    getListGallery();
    getListGalleryCategories();
  }, [page, inputValue]);



  const getListGalleryCategories = async () => {
    try {
      const { data, status } = await getGalleryCategories();
      if (status === 200) {
        const formattedData = data.map((item) => ({
          id: item,
          value: t(item)
        }));
        formattedData.unshift({
          id: '',
          value: t('selectbycategory')
        })
        setCategories(formattedData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSuccess = () => {
    setPage(1)
    getListGallery();
    getListGalleryCategories();
  };

  const handleClear = () => {
    setInputValue('');
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, totalPages: responseInfo?.totalPages }));
  };

  const handleEdit = (item) => {
    setOpenModal(true);
    setTypeAction('edit');
    setItem(item);
  };

  const handleCreate = () => {
    setOpenModal(true);
    setTypeAction('create');
    setItem({});
  };

  const deleteGalleryItem = async () => {
    const { status } = await deleteGallery(item.id);
    if (status === 200 || status === 201 || status === 204) {
      toast('success', t('eliminadocorrectamente'));
      getListGallery();
    } else {
      toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
    }
  };

  const handleWatchItem = (item) => {
    setItem(item);
    setOpenModalImage(true);
  };

  const handleDelete = (item) => {
    setOpenModalDelete(true);
    setItem(item);
  };


  return (
    <>
      <Title text={t('gallery')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col md={5} xs={12} className="d-flex text-start">
          <SearchTable
            handleClear={handleClear}
            typeselect={true}
            className="d-flex align-items-center"
          >
            <Col md={12} className="text-end">
              <Select
                choices={categories}
                value={inputValue || ''}
                onCheckedItem={setInputValue}
                className="input-control"

              />
            </Col>
          </SearchTable>
        </Col>
        <Col md={7} xs={12} className="text-end mt-3 mt-md-0">
          {userPermissions.includes('gallery.__add') && (
            <Button variant="secondary" color={'primary'} onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={['# Id', t('imagen'), t('category'), t('actions')]}
          page={page}
          totalPages={responseInfo?.totalPages}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          changePage={setPage}
        >
          {galleryItems?.map((item, index) => {
            return (
              <tr key={index}>
                <td className="text-light ">{`#${item.id}`}</td>
                <td className="text-light item-dropdown text-left">
                  <DropdownButton
                    title={<AiOutlineEye color="white" />}
                    onClick={() => handleWatchItem(item)}
                  />
                </td>
                <td className="text-light ">{item?.category}</td>
                <td className="text-light item-dropdown text-end">
                  <DropdownIcons
                    idItem={index}
                    handleEdit={
                      userPermissions.includes('gallery.__modify') && (() => handleEdit(item))
                    }
                    handleDelete={
                      userPermissions.includes('gallery.__delete') && (() => handleDelete(item))
                    }
                  />
                </td>
              </tr>
            );
          })}
          {openModalImage &&
            <WatchModal
              idGallery={item?.id}
              title={t('gallery')}
              item={item}
              show={openModalImage}
              setShow={setOpenModalImage}
              beforeTitle={t('gallery')}
            />
          }
          {openModal && <GalleryModal
            type={typeAction}
            show={openModal}
            setShow={setOpenModal}
            onSuccess={handleSuccess}
            item={item}
          />}
        </CustomTable>
      </div>
      <DeleteModalCustom
        openModal={openModalDelete}
        setOpenModal={setOpenModalDelete}
        handleDelete={deleteGalleryItem}
        deleteTitle={t('deletegallery')}
        beforeTitle={t('gallery')}
      />
    </>
  );
};
export default GalleryManagement;